<template>
    <div
        class="form-field form-field--notes details-column-notes"
        style="margin-left: 0"
    >
        <label>Notes</label>
        <button
            v-if="isAdd || editId"
            type="button"
            class="btn btn-add-note"
            @click="onOpenModal"
        >
            Close <i class="icon icon-cancel"></i>
        </button>
        <button
            type="button"
            class="btn btn-add-note"
            @click="onOpenModal"
            v-if="!isAdd && !editId"
        >
            Add <i class="icon icon-plus"></i>
        </button>
        <div class="row">
            <div
                class="col-xl-12 notes-wrap"
                ref="notes_list"
                :class="isAdd || editId ? 'notes-wrap--open' : ''"
                id="notes-wrap--agency"
            >
                <div class="notes-item" v-for="note in newNotes">
                    <div class="title">{{ note.title }}</div>
                    <input
                        type="hidden"
                        name="note_title[]"
                        :value="note.title"
                    />
                    <div
                        class="text"
                        v-if="note.body && note.body.length"
                        v-html="note.body"
                    ></div>
                    <input
                        type="hidden"
                        name="note_text[]"
                        :value="note.body"
                    />
                    <div class="date">
                        <i class="icon icon-calendar"></i>
                        {{ new Date().toDateString() }}
                    </div>
                    <input
                        type="hidden"
                        name="note_date[]"
                        :value="new Date().toDateString()"
                    />
                    <input
                        type="hidden"
                        name="only_for_admin[]"
                        :value="note.only_for_admin"
                    />
                </div>
                <div
                    class="notes-item"
                    v-for="note in currentNotes"
                    v-if="isAvailable(note)"
                >
                    <div class="title">
                        {{ note.title }}
                    </div>
                    <div
                        class="text"
                        style="white-space: pre-line"
                        v-if="note.body && note.body.length"
                        v-html="note.body"
                    ></div>

                    <div class="date">
                        <i class="icon icon-calendar"></i>
                        {{ note.created_date }}
                    </div>
                    <div class="note-controls">
                        <div class="edit" @click="onEdit(note.id)">
                            <i class="icon icon-pencil"></i>
                        </div>
                        <div class="delete" @click="onDeleteNote(note.id)">
                            <i class="icon icon-trash"></i>
                        </div>
                    </div>
                </div>
                <new-note
                    v-if="isAdd"
                    :is-admin="isAdmin"
                    :new-model="newModel"
                    @savingNote="newNote"
                    :updatingNotes="updateNotes"
                    :onCloseModal="onCloseModal"
                ></new-note>
                <edit-note
                    v-if="editId"
                    :is-admin="isAdmin"
                    :edit-id="editId"
                    :edit-data="editData"
                    :onUpdate="onUpdateNote"
                    :onCloseModal="onCloseModal"
                >
                </edit-note>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "Notes",
    props: {
        notes: {
            type: Array,
            default() {
                return [];
            },
        },
        isAdmin: {
            type: Boolean,
            default: false,
        },
        newModel: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentNotes: this.notes,
            newNotes: [],
            editId: null,
            isAdd: false,
        };
    },
    computed: {
        editData() {
            if (this.editId) {
                return [...this.newNotes, ...this.currentNotes].find(
                    (note) => note.id === this.editId
                );
            }
            return null;
        },
    },
    methods: {
        isAvailable(note) {
            return (
                !note.only_for_admin || (note.only_for_admin && this.isAdmin)
            );
        },
        newNote(note) {
            this.newNotes.unshift(note);
        },
        updateNotes(notes) {
            this.currentNotes = notes;
        },
        onEdit(id = null) {
            this.editId = id;
            this.$refs.notes_list.scrollTop = 0;
        },
        onOpenModal() {
            if (this.isAdd) {
                this.isAdd = false;
                return;
            }

            if (this.editId) {
                this.editId = null;
                return;
            }

            this.isAdd = true;
            this.$refs.notes_list.scrollTop = 0;
        },
        onUpdateNote(id, data) {
            if (this.currentNotes.length > 0) {
                this.currentNotes = this.currentNotes.map((note) => {
                    if (note.id === id) {
                        note.title = data.title;
                        note.body = data.body;
                        note.only_for_admin = data.only_for_admin;
                    }

                    return note;
                });
            }

            if (this.newNotes.length > 0) {
                this.newNotes = this.newNotes.map((note) => {
                    if (note.id === id) {
                        note.title = data.title;
                        note.body = data.body;
                        note.only_for_admin = data.only_for_admin;
                    }

                    return note;
                });
            }

            this.editId = null;
        },
        onCloseModal() {
            this.isAdd = false;
            this.editId = null;
        },

        onUpdateAfterDelete(id) {
            this.currentNotes = this.currentNotes.filter(
                (item) => item.id !== id
            );
            this.newNotes = this.newNotes.filter((item) => item.id !== id);
        },

        async onDeleteNote(id) {
            if (!id) {
                return;
            }

            await axios
                .delete(`/notes/${id}/delete`)
                .then(() => {
                    this.onUpdateAfterDelete(id);
                })
                .catch((err) => console.log("Delete note error", err));
        },
    },
};
</script>
